import { render, staticRenderFns } from "./VenueAnalysisSummary.vue?vue&type=template&id=24b06036&"
import script from "./VenueAnalysisSummary.vue?vue&type=script&lang=js&"
export * from "./VenueAnalysisSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports